import Column from '@components/Column';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';

function ItemDetailSkeleton() {
    return (
        <Column fullWidth spacing={2}>
            <Container fullWidth spacing={3} align='center'>
                <Skeleton width={110} height={110} />
                <Skeleton width={200} height={30} />
                <Skeleton width={250} height={20} />
            </Container>
            <Skeleton width='100%' height={88} />
        </Column>
    );
}

const Container = styled(Column)`
    padding: 32px 20px 16px;
`;

export default ItemDetailSkeleton;
